// extracted by mini-css-extract-plugin
module.exports = {"card":"cardLink_card__3clK8","chevron":"cardLink_chevron__6oIx-","iconCol":"cardLink_iconCol__3BZVU"};